"use client";

import { c as _c } from "react/compiler-runtime";
import { RelationshipDialog } from "@/components/relationship-dialog";
import { useRelationshipSelection } from "@/hooks/use-relationship-selection";
export function RelationshipSelectionWrapper() {
  const $ = _c(9);
  const {
    shouldShowSelection,
    markSelectionShown,
    hideSelection
  } = useRelationshipSelection();
  let t0;
  if ($[0] !== markSelectionShown) {
    t0 = relationship => {
      markSelectionShown();
    };
    $[0] = markSelectionShown;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleComplete = t0;
  let t1;
  if ($[2] !== hideSelection || $[3] !== markSelectionShown) {
    t1 = () => {
      markSelectionShown();
      hideSelection();
    };
    $[2] = hideSelection;
    $[3] = markSelectionShown;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleClose = t1;
  let t2;
  if ($[5] !== handleClose || $[6] !== handleComplete || $[7] !== shouldShowSelection) {
    t2 = <RelationshipDialog isOpen={shouldShowSelection} onClose={handleClose} onComplete={handleComplete} mode="selection" />;
    $[5] = handleClose;
    $[6] = handleComplete;
    $[7] = shouldShowSelection;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}